import { Container, Row, Col } from 'reactstrap';
import styles from './styles.module.scss';

export const ImageWithTextWithOverlay = ({
  className,
  image,
  content,
  reversed,
}) => {

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <Row className={`align-items-center ${reversed ? "flex-row-reverse" : ""}`}>
          <Col md={5} className={`left-column mb-5 mb-md-0 ${reversed ? "ps-md-5" : "pe-md-5"}`}>
            <figure className="m-0">
              <img src={image?.url ? image?.url : "/site-assets/placeholders/img-placeholder.jpg"} alt={image?.alt} className="card-img rounded-4" />
            </figure>
          </Col>
          {content &&
            <Col md={7} className={`right-column ${reversed ? "pe-md-5" : "ps-md-5"}`}>
              <div className="mb-4">
                <div className="mt-4" dangerouslySetInnerHTML={{ __html: content }} />
              </div>
            </Col>
          }
        </Row>
      </Container>
    </section>
  )
}

export default ImageWithTextWithOverlay;
